import { render, staticRenderFns } from "./InternationalWire.vue?vue&type=template&id=1f25b313&scoped=true&"
import script from "./InternationalWire.vue?vue&type=script&lang=js&"
export * from "./InternationalWire.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWire.vue?vue&type=style&index=0&id=1f25b313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25b313",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f25b313')) {
      api.createRecord('1f25b313', component.options)
    } else {
      api.reload('1f25b313', component.options)
    }
    module.hot.accept("./InternationalWire.vue?vue&type=template&id=1f25b313&scoped=true&", function () {
      api.rerender('1f25b313', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/templatePanels/InternationalWire.vue"
export default component.exports